// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes placeholderLoader{0%{background-position:-500px 0}to{background-position:500px 0}}.category-view__list-chained.category-list.--common{border-top:1px solid rgba(0,0,0,.25);margin-top:clamp(1.875rem,.94rem + 3.13vw,4.0625rem);padding-top:clamp(1.875rem,.94rem + 3.13vw,4.0625rem)}@media(max-width:1399px){.adv-banner-block+.category-view__list-chained.category-list.--common{border-top:0;margin-top:0;padding-top:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
